import { BI_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { YearlyResultResponse } from '../types';
import { QUERY_KEY_MANAGER_PERFORMANCE } from '../query-keys';

type Params = {
  managerId: number | null;
  year: number;
};

const getManagerYearlyResult = async ({ managerId, year }: Params) => {
  const { data } = await api.get<YearlyResultResponse>(
    `${BI_BASE_URL}/managers/manager/${managerId}/result/yearly`,
    {
      params: { year },
    }
  );

  return data;
};

export const useGetManagerYearlyResult = ({
  managerId,
  year,
}: Params): UseQueryResult<YearlyResultResponse, unknown> => {
  return useQuery({
    queryKey: [QUERY_KEY_MANAGER_PERFORMANCE.YEARLY_RESULT, managerId, year],
    queryFn: () => {
      return getManagerYearlyResult({ managerId, year });
    },
    enabled: managerId !== null,
  });
};
